module.exports = __webpack_public_path__ + "media/images/password-ead49bb109afceb4900cfd690835468b.svg";